/* eslint-disable react/no-unescaped-entities */
import SEO from "@/components/core/SEO"
import MainLayout from "@/components/layouts/MainLayout"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { ReactElement } from "react"

const Page = () => {
  return (
    <div className="px-16 py-8">
      <SEO />
      <h1>Zásady zpracování osobních údajů</h1>
      <h2>1. Úvod</h2>
      <p>
        Společnost Scholarum z.s., IČO: 11752581, se sídlem Melantrichova 971/19, 110 00 Praha, zapsaná v obchodním
        rejstříku vedeném Městským soudem v Praze pod spisovou značkou L 75180 (dále jen "Scholarum"), je správcem
        osobních údajů.
      </p>
      <p>
        V tomto dokumentu naleznete informace o tom, jakým způsobem Scholarum zpracovává Vaše osobní údaje v rámci
        Vašeho užívání naší aplikace Poznejme Česko. Dále zde naleznete informace o účelech, pro které jsou osobní údaje
        zpracovávány, kategoriích zpracovávaných osobních údajů, právním základu zpracování osobních údajů a o Vašich
        právech v oblasti zpracování osobních údajů.
      </p>
      <h2>2. Pro jaké účely a z jakého titulu zpracováváme Vaše osobní údaje?</h2>
      <p>Osobní údaje zpracováváme k následujícím účelům:</p>
      <ul>
        <li>
          <strong>Zajištění správného fungování hry:</strong> Abychom vás mohli kontaktovat v případě technických potíží
          a zajišťovat co nejlepší fungování hry, sledování vašeho postupu ve hře a její zlepšování. Právním titulem
          zpracování pro tento účel jsou naše oprávněné zájmy.
        </li>
        <li>
          <strong>Marketingové účely:</strong> V omezené míře zpracováváme údaj e-mailové adresy pro účely přímého
          marketingu při propagaci našich webových stránek nebo naší aplikace. Právním titulem zpracování pro tento účel
          jsou naše oprávněné zájmy; na Váš e-mail můžeme zasílat newsletter o naší činnosti, novinkách v aplikaci,
          nových funkcích apod. pokud se zasíláním tohoto newsletteru vyslovíte souhlas, který však můžete kdykoliv
          odvolat (např. proklikem na odkaz uvedený v každém jednotlivém newsletteru, jehož prostřednictvím se můžete
          odhlásit).
        </li>
        <li>
          <strong>Statistické účely:</strong> Zpracováváme údaje nezbytné pro účely pochopení a analýzy využívání
          aplikace a našich webových stránek za účelem zlepšování a vývoje našich služeb, toto zahrnuje například
          analýzu uživatelských preferencí, chování a akce v aplikaci na webu.
        </li>
        <li>
          <strong>Ověření polohy Vašeho zařízení, na kterém je aplikace umístěna:</strong> Vzhledem k povaze aplikace,
          která je mimo jiné určena ke vzdělávacím účelům ve spojení s určitými místy (památky, města, přírodní památky
          apod.) a personalizaci zážitku při užívání aplikace, zpracováváme údaj o poloze zařízení tak, aby aplikace
          byla schopná nabídnout vhodné funkce pro aktuální polohu, kde se zařízení s aplikací nalézá, neověřujeme
          polohu zařízení s vysokou přesností, pouze v omezené míře.
        </li>
        <li>
          <strong>Účast v soutěži:</strong> Pokud se budete účastnit některé námi pořádané soutěže, pak budou Vaše údaje
          zpracovávány pro účely pořádání této soutěže a další účely související s danou soutěží, to vždy za podmínek
          uvedených v konkrétních pravidlech jednotlivé soutěže. Právním titulem pro zpracování údajů pro tyto účely je
          smlouva, která mezi námi bude uzavřena tím, že budete souhlasit s podmínkami soutěže. V některých případech
          mohou být údaje v souvislosti s účastí v soutěži zpracovány také na základě jiného právního titulu, zejména
          oprávněného zájmu nebo na základě souhlasu, a to vždy dle podmínek konkrétní soutěže.
        </li>
      </ul>
      <h2>3. Kategorie subjektu osobních údajů</h2>
      <p>
        <strong>Neregistrovaný uživatel</strong> – naší aplikaci můžete využívat i v případě, že nejste registrovaným
        uživatelem. V tomto případě však nebude možné sbírat body.
      </p>
      <p>
        <strong>Registrovaný uživatel</strong> – registrace umožňuje plné využití všech funkcí aplikace, např. uložit
        rozehranou hru, vytvořit si vlastního avatara, sbírat herní měnu a vybírat si odměnu za získanou herní měnu. Při
        registraci můžeme u osob, které nám nemohou platně poskytnout souhlas se zpracováním jejich osobních údajů
        požádat o zadání e-mailové adresy rodiče nebo jiného zákonného zástupce.
      </p>
      <h2>4. Jaké osobní údaje zpracováváme</h2>
      <p>V souvislosti s využíváním naší aplikace můžeme zpracovávat následující kategorie osobních údajů:</p>
      <ul>
        <li>
          <strong>Údaje profilu:</strong> zahrnují nezbytné identifikační údaje, tedy vaše uživatelské jméno a heslo.
        </li>
        <li>
          <strong>Údaje o používání:</strong> zahrnují informace o tom, jak používáte naše webové stránky, aplikaci,
          dále požadované nebo využité odměny nebo výhody.
        </li>
        <li>
          <strong>Uživatelská aktivita:</strong> zahrnují herní údaje, jako jsou pokrok ve hře, herní úspěchy, doba
          hraní jednotlivých her a další herní statistiky.
        </li>
        <li>
          <strong>Technické údaje:</strong> zahrnují adresu internetového protokolu (IP), vaše přihlašovací údaje, typ a
          verzi prohlížeče, nastavení časového pásma a polohu, typy a verze modulů plug-in prohlížeče, operační systém a
          platformu, ID uživatele, MAC ID a další technologie v zařízeních, která používáte pro přístup na tyto webové
          stránky.
        </li>
        <li>
          <strong>Poloha zařízení uživatele:</strong> zahrnuje upozorňování uživatele na místa s úkoly (zastavení), i
          když není momentálně otevřená. Údaje o poloze (location) uživatele nejsou nijak shromažďovány a uchovávány.
          Jedinou výjimkou jsou záznamy o místech a čase, kde a kdy plnil uživatel úkoly spojené s hrou. Nikdy o vás
          aktivně neshromažďujeme žádné zvláštní kategorie osobních údajů (sem patří zejm. údaje o vašem rasovém nebo
          etnickém původu, náboženském vyznání, sexuální orientaci, politických názorech, informace o vašem zdraví
          apod.).
        </li>
      </ul>
      <h2>5. Jak Vaše osobní údaje získáváme?</h2>
      <p>Vaše osobní údaje získáváme přímo od Vás z údajů, které nám sdělíte při registraci.</p>
      <h2>6. Po jakou dobu zpracováváme Vaše osobní údaje?</h2>
      <p>
        Osobní údaje zpracováváme pouze po dobu, kdy bude existovat registrovaný uživatelský účet. Právo vymazat svůj
        účet včetně všech shromažďovaných údajů je možné přímo z mobilní aplikace (Profil / Smazat účet). Uživatel má
        možnost získat návod na smazání účtů v sekci FAQ.
      </p>
      <h2>7. Komu Vaše osobní údaje zpřístupňujeme?</h2>
      <p>
        Se zajištěním některých našich smluvních nebo zákonných povinností nám pomáhají další osoby, které jsou v pozici
        zpracovatelů. Se zpracovateli máme uzavřené písemné smlouvy, ve kterých je sjednáno plnění povinností v oblasti
        ochrany osobních údajů, aby Vaše údaje zůstaly v bezpečí a většina zpracovatelů má podrobné informace o
        zpracování osobních údajů v situaci, kdy je zpracovatelem pro jiného správce na svých webových stránkách.
        Konkrétně využíváme následující zpracovatele: poskytovatelé IT služeb.
      </p>
      <h2>8. Ochrana osobních údajů dětí</h2>
      <p>
        Velmi nám záleží na tom, aby byly děti na internetu v bezpečí. Když zpracováváme osobní údaje dětí, provádíme
        dodatečné kroky k ochraně jejich soukromí, mezi které patří:
      </p>
      <ul>
        <li>
          Informování rodičů, jaké osobní údaje od dětí shromažďujeme, ukládáme, používáme a zpracováváme, a vysvětlení,
          zda tyto informace sdílíme;
        </li>
        <li>
          Omezení způsobu, jakým shromažďujeme, ukládáme, používáme a zpracováváme osobní údaje od dětí, aby byly
          shromažďovány pouze údaje, které jsou nutné k tomu, aby se děti mohly účastnit on-line aktivit;
        </li>
        <li>
          Udělení přístupu rodičům nebo poskytnutí možnosti, aby rodiče mohli požádat o přístup k osobním údajům, které
          jsme od dětí shromáždili. Rodiče také mohou požádat, aby osobní údaje jejich dětí byly změněny nebo
          odstraněny.
        </li>
      </ul>
      <p>Zde jsou některé příklady toho, kdy shromažďujeme údaje dětí:</p>
      <ul>
        <li>
          Když se děti registrují on-line. Shromažďujeme pouze uživatelské jméno, emailovou adresu a heslo, které slouží
          pro účely přihlášení. Tyto informace používáme k úpravě aplikace, aby vyhovovala konkrétnímu uživateli a
          zlepšování našich služeb, například upravováním obtížnosti her a úkolů.
        </li>
        <li>
          Důrazně dětem doporučujeme, aby si vytvořily uživatelské jméno, které nebude obsahovat žádné osobní údaje.
        </li>
      </ul>
      <h2>9. Jaká máte práva v oblasti ochrany osobních údajů?</h2>
      <p>
        Vaše údaje zpracováváme zcela transparentním způsobem. Kdykoliv během zpracování Vašich osobních údajů můžete
        využít následujících práv:
      </p>
      <ul>
        <li>právo na přístup k osobním údajům</li>
        <li>právo na opravu a doplnění</li>
        <li>právo na výmaz</li>
        <li>právo na omezení zpracování</li>
        <li>právo vznést námitku</li>
        <li>
          právo podat stížnost u dozorového úřadu, kterým je Úřad pro ochranu osobních údajů, se sídlem pplk. Sochora
          27, Praha 7, PSČ 170 00.
        </li>
      </ul>
      <h2>10. Bližší informace a kontaktní údaje</h2>
      <p>
        Máte-li otázky nebo obavy ohledně zpracování Vašich osobních údajů, nebo pokud si přejete uplatnit jakákoli svá
        práva, kontaktujte nás prostřednictvím kontaktů uvedených níže:
      </p>
      <p>Scholarum z.s. </p>
      <br />
      PhDr. Eliška Bajtová, ředitelka spolku
      <br />
      <a href="mailto:eliska.bajtova@scholarum.cz">eliska.bajtova@scholarum.cz</a>
      <br />
      <p> Melantrichova 971/19, 110 00 Praha 1</p>
      <p>K poslední aktualizaci tohoto informačního memoranda došlo 11. 4. 2024.</p>
    </div>
  )
}

Page.getLayout = function getLayout(page: ReactElement) {
  return <MainLayout>{page}</MainLayout>
}

export async function getStaticProps({ locale }) {
  const translations = await serverSideTranslations(locale, ["common", "dashboard"])

  return {
    props: {
      ...translations,
    },
  }
}

export default Page
